import { AfterViewInit, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error-404',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './error-404.component.html',
  styleUrl: './error-404.component.scss',
})
export class Error404Component {
  @Input() showButton: boolean = true;
}
